import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { ChatMessage } from '@/hooks/Groups/useAIChat';
import { Business } from '@/types/businesses';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}

// Initialize from localStorage synchronously to avoid flash
const getInitialSidebarState = (): boolean => {
  if (typeof window === 'undefined') return false;
  const stored = localStorage.getItem('sidebar-collapsed');
  return stored ? (JSON.parse(stored) as boolean) : false;
};

export const sidebarCollapseAtom = atomWithStorage<boolean>(
  'sidebar-collapsed',
  getInitialSidebarState(),
);

export const currentBusinessAtom = atom<Business | null>(null);

export const currentUserAtom = atom<User | null>(null);

export const isAuthenticatedAtom = atom<boolean>(false);

export const isLoadingAuthAtom = atom<boolean>(true);

export const copilotChatHistoriesAtom = atom<Record<string, ChatMessage[]>>({});

export const roleAtom = atom<'superadmin' | 'admin' | 'user' | null>(null);
